import axios from 'axios';
import { baseUrl_SPB } from '../BaseUrl';

const SaveRosterTemplate = async (payload, token) => {
  let templateRulesString = payload?.templateRules;

  if (typeof templateRulesString !== 'string') {
    try {
      templateRulesString = JSON.stringify(templateRulesString || { shifts: [] });
    } catch (serializationError) {
      templateRulesString = JSON.stringify({ shifts: [] });
    }
  }

  const outboundPayload = {
    ...(payload || {}),
    templateRules: templateRulesString,
  };

  const response = await axios.post(
    `${baseUrl_SPB}/api/v1/rostertemplate/save`,
    outboundPayload,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response?.data;
};

export default SaveRosterTemplate;